var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-count',{attrs:{"payload":_vm.payload,"namespace":_vm.namespace,"button-size":"S","max-value":"999"},on:{"updateCount":_vm.updateCount},scopedSlots:_vm._u([{key:"unit",fn:function(){return [_vm._v("回線")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }